"use client";

import { ProductOption } from "@/api/generated-api";
import VariantOptionBaseView, { VariantOptionViewItem } from "./variant-option-base-view";

interface VariantOptionOptionGroupProps {
  title: string;
  items: ProductOption[];
  selectedId?: number;
  onSelect: (id: number) => void;
}

const VariantOptionOptionGroup = ({ title, items, selectedId, onSelect }: VariantOptionOptionGroupProps) => {
  const viewItems: VariantOptionViewItem[] = items.map(item => ({
    key: item.id,
    title: item.title,
    colour: item.colour,
  }));

  return <VariantOptionBaseView title={title} items={viewItems} selectedKey={selectedId} onSelect={onSelect} />;
};

export default VariantOptionOptionGroup;
